import React, { useState, useEffect, useRef, Suspense } from 'react';
// import { connect, useDispatch } from 'react-redux';
import { DEGREES, EDUCATION_LINK, FINAL_RESUME, HEADING_LINK, MONTHS, NEXT_EDUCATION_LABEL, NEXT_LABEL, NEXT_SKILLS_LABEL, NEXT_SUMMARY_LABEL, NEXT_WORKHISTORY_LABEL, SKILLS_LINK, WORKHISTORY_LINK, START_YEAR } from '../../constants/constants';
import { Redirect } from 'react-router';
import ErrorValidator from '../../ErrorValidator';
import TickIcon from '../../images/tick.svg';
import DatePicker from "react-datepicker";
// import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";
import DraftEditor from '../common/DraftEditor';
import GPTSuggestionPopup from '../common/GPTSuggestionPopup';
import ErrorIcon from '../common/ErrorIcon';
import { useResume } from '../../context/ResumeContext';
//import PhrasesPopup from './common/PhrasesPopup';
const PhrasesPopup = React.lazy(() => import("../common/PhrasesPopup"));

const AddEducation = props => {
  const education = props.data
  const currDate = Date.now();
  const currentYear = new Date().getFullYear();
  const errorStyle = { color: 'red', fontSize: '10px' }
  const {
    getFieldSuggestionId,
    showSuggestionPopup
  } = useResume();
  const validatorSet = {
    // school_name: { empty: "Please Enter School Name" },
    // school_location: { empty: "Please Enter Location" },
    degree: {
      // empty: "Please enter degree",
      other: {
        msg: "Please enter degree",
        validator: val => val == 'select'
      }

    },
    // field_of_study: {
    //   other1: {
    //     msg: "Please Enter Field Of Study",
    //     validator: val => {
    //       return ((education.degree != "" && education.field_of_study == "") ? true : false)
    //     }
    //   }
    // },
    // start_date: {
    //   other4: {
    //     msg: "Please select start year to complete the date.",
    //     validator: val => {
    //       let startArr = (education.start_date).split(' ');
    //       // startDate = new Date(education.start_date);
    //       // endDate = new Date(education.end_date);
    //       // return ((!education.currently_studying && education.end_date.trim().length && (new Date(education.start_date)).getTime() >= (new Date(education.end_date)).getTime()) ? true : false)
    //       if (education.start_date.length && startArr.length == 1 && !(/\d{4}/).test(startArr[0])) {
    //         return true;
    //       }
    //     }
    //   },
    //   other1: {
    //     msg: "Start Date should be less then current date",
    //     validator: val => {
    //       // startDate = new Date(education.start_date);
    //       return education.start_date.length && currDate < (new Date(education.start_date)).getTime()
    //     }
    //   }
    // },
    // end_date: {
    //   // other1: {
    //   //   msg: "Please Enter End Date",
    //   //   validator: val => {
    //   //     return ((education.end_date == '' && !education.currently_studying) ? true : false)
    //   //   }
    //   // },
    //   other4: {
    //     msg: "Please select End Year to complete the date.",
    //     validator: val => {
    //       let endArr = (education.end_date).split(' ');
    //       if (education.end_date.length && !education.currently_studying && endArr.length == 1 && !(/\d{4}/).test(endArr[0])) {
    //         return true;
    //       }
    //     }
    //   },
    //   other2: {
    //     msg: "End Date should be greated then start date",
    //     validator: val => {
    //       return education.start_date.length && education.end_date.length && !education.currently_studying && (new Date(education.start_date)).getTime() > (new Date(education.end_date)).getTime()
    //     }
    //   },
    //   other3: {
    //     msg: "End Date should be less then current date",
    //     validator: val => {
    //       let startArr = (education.start_date).split(' ');
    //       // endDate = new Date(education.end_date);
    //       // return ((!education.currently_studying && education.end_date.trim().length && currDate < (new Date(education.end_date)).getTime()) ? true : false)
    //       return education.end_date.length && !education.currently_working && currDate < (new Date(education.end_date)).getTime() 
    //     }
    //   },
    // }
  };
  //For error validations
  const vObj = new ErrorValidator(validatorSet)
  // const dispatch = useDispatch();
  const [error, setError] = useState({})

  const [openList, setOpenList] = useState({ list: { start_month: false, start_year: false, end_month: false, end_year: false } });
  //const [openEndMonthList, setOpenEndMonthList] = useState(false);
  //Flag is Do Next redirect
  const [checkField, setCheckField] = useState('');
  //Flag to show AI popup
  const [showAIPopup, setShowAIPopup] = useState(false);
  const [showPhrasePopUp, setShowPhrasePopUp] = useState(false);

  const getYears = () => {
    let options = [];
    for (var i = currentYear; i >= START_YEAR; i--) {
      options.push(i);
    }
    return options;
  }


  const removeError = (e) => {
    setError({ ...error, [e.target.name]: '' })
  }

  const fieldFocus = e => {
    setCheckField(e.target.name);
    removeError(e);
    props.updateEducation({ validated: { ...education.validated, [e.target.name]: false } }, props.id)
  }

  const nrFieldFocus = e => {
    setCheckField(e.target.name);
  }

  const nrFieldBlur = e => {
    setCheckField('');
    props.reviewIt()
  }

  const fieldBlur = e => {
    setCheckField('');
    // const er = validateFields(e.target.name)
    
    const er = vObj.validateFields(e.target.value, e.target.name)
    if (!Object.keys(er).length) {
      props.updateEducation({ validated: { ...education.validated, [e.target.name]: true } }, props.id)
    } else setError({ ...error, ...er });
    props.reviewIt()
  }

  const formatDate = raw => {
    let d = null, m, y
    //Only year found in case of linkedin profile upload
    if (/^\s*\d{4}/.test(raw.trim()))   m = 'January', y = raw.trim()
    else [m, y] = raw.split(' ')
    const mm = MONTHS.indexOf(m) + 1
    raw.length && (d = new Date(`${y}-${mm.toString().length == 1 ? '0'.concat(mm) : mm}-02`))
    return d
  }

  // const updateEndDate = (v) => {
  //   var end_date = '';
  //   var end_month = document.getElementById('end_month');
  //   var end_year = document.getElementById('end_year');
  //   end_date = end_month.value + ' ' + end_year.value;

  //   props.updateEducation(
  //     { end_date: end_date.trim() },
  //     props.id
  //   );
  // }


  //date manipulation
  let startDate, startDateV, endDate, endDateV;

  if (education.start_date.length) {
    startDateV = startDate = new Date(education.start_date);

  }
  else {
    startDate = new Date();
    startDateV = ''
  }

  if (education.end_date.length) {
    endDateV = endDate = new Date(education.end_date);
  }
  else {
    endDate = new Date();
    endDateV = ''
  }

  const toggleDropDown = (key) => {
    setOpenList({ list: { [key]: !openList.list[key] } });
  }

  const emptyAiData = () => {
    const aidata = (localStorage.getItem('aidata') ? JSON.parse(localStorage.getItem('aidata')) : {});
    if(aidata.job){
      delete aidata.job;
      //localStorage.removeItem('aidata');
      localStorage.setItem('aidata', JSON.stringify(aidata));
    }
  }

  const _getFieldSuggestionId = (field) => {
    return  props?.review && getFieldSuggestionId('education_history',field, props.id);
  }
  const clickHandler = (element_id) => {
    showSuggestionPopup(element_id);
  };

  return (<div className="editor-form">
      <div className="form-row column-2">
        <div className="field-wrap" id={_getFieldSuggestionId('school_name')}>
          {/* <label htmlFor="school_name" className={`label${checkField == 'school_name' ? ' label-focus': '' }`}>School Name { props._hasReviewSuggestions(props.id, 'school_name') && <ErrorIcon onClick={() => clickHandler(_getFieldSuggestionId('school_name'))} />}</label> */}
          <input
            placeholder="School Name"
          className={`validate ${ props._hasReviewSuggestions(props.id, 'school_name') && 'review-error'}`}
            type="text"
            name="school_name"
            value={education.school_name}
            onChange={(e) => {
              removeError(e);
              props.updateEducation(
                { school_name: e.target.value },
                props.id
              );
            }}
            onFocus={(e) => fieldFocus(e)}
            onBlur={(e) => fieldBlur(e)}
          />
        {error.school_name && <span style={errorStyle}>{error.school_name}</span>}
        </div>
        <div className="field-wrap" id={_getFieldSuggestionId('school_location')}>
        {/* <label className={`label${checkField == 'school_location' ? ' label-focus': '' }`}>School Location { props._hasReviewSuggestions(props.id, 'school_location') &&  <ErrorIcon onClick={() => clickHandler(_getFieldSuggestionId('school_location'))} />}</label> */}
          <input
            placeholder="School Location"
            className={`form-input borderaccent validate ${ props._hasReviewSuggestions(props.id, 'school_location') && 'review-error'}`}
            type="text"
            name="school_location"
            value={education.school_location}
            onChange={(e) => {
              removeError(e);
              props.updateEducation(
                { school_location: e.target.value },
                props.id
              );
            }}
            onFocus={(e) => fieldFocus(e)}
            onBlur={(e) => fieldBlur(e)}
          />
          {error.school_location && (
            <span style={errorStyle}>{error.school_location}</span>
          )}
        </div>
      </div>
      <div className="form-row column-2" >
        <div className="field-wrap date-field light-green" id={_getFieldSuggestionId('start_date')}>
          {/* <label htmlFor="start_date" className={`label${checkField == 'start_date' ? ' label-focus': '' }`}>Start Date { props._hasReviewSuggestions(props.id, 'start_date') && <ErrorIcon onClick={() => clickHandler(_getFieldSuggestionId('start_date'))} />}</label> */}
          {/* <CalendarIcon /> */}
          <DatePicker
            showMonthYearPicker
            placeholderText="Start Date"
            value={formatDate(education.start_date)}
            name="start_date"
            selected={formatDate(education.start_date)}
            className={`form-input borderaccent custom-date-picker validate ${ props._hasReviewSuggestions(props.id, 'start_date') && 'review-error'}`}
            dateFormat="MMMM yyyy"
            onChange={(e) => {
              props.updateEducation(
                { start_date: `${MONTHS[e.getMonth()]} ${e.getFullYear()}` },
                props.id
              );
              props.reviewIt()
            }}
            onFocus={(e) => fieldFocus(e)}
            onBlur={(e) => fieldBlur(e)}
            onChangeRaw={e => e.preventDefault()}
            autoComplete="off"
          />
          {error.start_date && <span style={errorStyle}>{error.start_date}</span>}
        </div>
        <div className="field-wrap date-field light-green" id={_getFieldSuggestionId('end_date')}>
          {/* <label className={`label${checkField == 'end_date' ? ' label-focus': '' }`} htmlFor="end_date">End Date { props._hasReviewSuggestions(props.id, 'end_date') && <ErrorIcon onClick={() => clickHandler(_getFieldSuggestionId('end_date'))} />}</label> */}
          {/* <CalendarIcon /> */}
          <DatePicker
            showMonthYearPicker
            placeholderText="End Date"
            value={formatDate(education.end_date)}
            name="end_date"
            selected={formatDate(education.end_date)}
            className={`form-input borderaccent custom-date-picker validate ${ props._hasReviewSuggestions(props.id, 'end_date') && 'review-error'}`}
            dateFormat="MMMM yyyy"
            disabled={education.currently_studying ? "disabled" : ""}
            autoComplete="off"
            onChange={(e) => {
              setError({ ...error, end_date: '' })
              props.updateEducation(
                { end_date: `${MONTHS[e.getMonth()]} ${e.getFullYear()}` },
                props.id
              );
              props.reviewIt()
            }}
            onFocus={(e) => { education.currently_working ? '' : fieldFocus(e) }}
            onBlur={(e) => fieldBlur(e)}
            onChangeRaw={e => e.preventDefault()}
          />
          {error.end_date && <span style={errorStyle}>{error.end_date}</span>}


        <div className="on-off-btn light-green">
          <p>
            <input
              type="checkbox"
              id="currentEducation"
              defaultChecked={education.currently_studying ? "checked" : ""}
              onChange={(e) => {
                props.updateEducation(
                  { currently_studying: e.target.checked, end_date: '' },
                  props.id
                );
                props.reviewIt()
              }}
            />
            <span><i></i></span> I currently study here</p>

        </div>
        </div>
      </div>
      <div className="form-row column-2">
        <div className="field-wrap" id={_getFieldSuggestionId('degree')}>
          {/* <label htmlFor="degree" className={`label${checkField == 'degree' ? ' label-focus': '' }`}>Degree { props._hasReviewSuggestions(props.id, 'degree') && <ErrorIcon onClick={() => clickHandler(_getFieldSuggestionId('degree'))} />}</label> */}
          <input
            placeholder="Degree"
            type="text"
            name="degree"
            value={education.degree}
            onChange={(e) => {
              removeError(e);
              props.updateEducation(
                { degree: e.target.value },
                props.id
              )
            }}
            onFocus={(e) => nrFieldFocus(e)}
            onBlur={(e) => nrFieldBlur(e)}
            className={`form-input borderaccent ${ props._hasReviewSuggestions(props.id, 'degree') && 'review-error'}`}
          />
          {error.degree && <span style={errorStyle}>{error.degree}</span>}
        </div>
        <div className="field-wrap" id={_getFieldSuggestionId('field_of_study')}>
          {/* <label className={`label${checkField == 'field_of_study' ? ' label-focus': '' }`}>Field of Study { props._hasReviewSuggestions(props.id, 'field_of_study') && <ErrorIcon onClick={() => clickHandler(_getFieldSuggestionId('field_of_study'))} />}</label> */}
          <input
            type="text"
            placeholder="Field of Study"
            name="field_of_study"
            value={education.field_of_study}
            onChange={(e) => {
              removeError(e);
              props.updateEducation(
                { field_of_study: e.target.value },
                props.id
              )
            }}
            onFocus={(e) => nrFieldFocus(e)}
            onBlur={(e) => nrFieldBlur(e)}
            className={`form-input borderaccent ${ props._hasReviewSuggestions(props.id, 'field_of_study') && 'review-error'}`}
          />
          {/* {error.field_of_study && (
            <span style={errorStyle}>{error.field_of_study}</span>
          )} */}
        </div>
      </div>
      <div className="form-row">
        <div className="field-wrap" id={_getFieldSuggestionId('description')}>
          <label className="label editor-label">Description</label>

          {/* <label className="label editor-label">Description { props._hasReviewSuggestions(props.id, 'description') && <ErrorIcon onClick={() => clickHandler(_getFieldSuggestionId('description'))} />}</label> */}
          {/* <p className="editor-subtitle">Get help writing your bullet points with the pre-written examples below.</p> */}
          <div className="rich-text-editor">
            <DraftEditor
              name="description"
              placeholder="e.g. Coursework toward: Degree Title, School Name, City, ST or online… "
              className={`validate ${ props._hasReviewSuggestions(props.id, 'description') && 'review-error'}`}
              textAlignment="left"
              value={education.description}
              //onChange={(e) => { props.updateJob({ description: e.target.value }, props.id) }}
              onInputChange={(val) => {
                props.updateEducation({ description: val }, props.id);
              }}
            chatGptButton={true}
            phrasesButton={true}
            colorType="light-green"
              showAIPopup={showAIPopup}
              setShowAIPopup={(showAIPopup) => { setShowAIPopup(showAIPopup) }}
            showPhrasePopUp={showPhrasePopUp}
            setShowPhrasePopUp={(showPhrasePopUp) => { setShowPhrasePopUp(showPhrasePopUp) }}
            reviewEnabled={props?.review}
            reviewFieldParams = {{section: 'education_history', row_id: props.id, field: 'description'}}
            onBlur={() => props.reviewIt()}
            />
            {error.description && (
              <span style={errorStyle}>{error.description}</span>
            )}
            {showAIPopup 
              && <GPTSuggestionPopup 
                section="education"
                phrase={education.field_of_study}
                id={props.id}
                data={education}
                updateAction={props.updateEducation}
                setShowAIPopup={(a) => setShowAIPopup(a)}
              /> 
            }
          {showPhrasePopUp 
          ? 
            <Suspense fallback={<div>Loading</div>}>
              <PhrasesPopup 
                section='education_history'
                phrase={education.field_of_study}
                id={props.id}
                data={education}
                updateAction={props.updateEducation}
                setShowPhrasePopUp={(s) => setShowPhrasePopUp(s)}
              />
            </Suspense> : ''}
          </div>
        </div>
      </div>
  </div>);
}

export default AddEducation;